import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Button, Container, Spacer } from '@emburse/embark-core';
import SingleColumnLayout from '../../components/Layouts/SingleColumnLayout';
import APIConfigModal from './APIConfigModal';
import APIConfigCredential from './APIConfigCredential';
import APIConfigHeader from './APIConfigHeader/APIConfigHeader';
import { changeInternalCred, deleteCertifyAPIKey, generateCertifyAPIKey, generateCertifyAPISecret, updateAPIName } from '../../api/apiConfig';
import { APIConfigModalTypes } from '../../interfaces/APIConfig';
import { $t, useTranslation } from '../../hooks/useTranslation';
function APIConfig({ strCompanyName, strCompanyID, booIsCertifyAdmin, intMaxCreds, arrCreds }) {
    useTranslation();
    const [selectedCredential, setSelectedCredential] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [modalType, setModalType] = useState(null);
    const [internalCreds, setInternalCreds] = useState(() => {
        const ic = [];
        arrCreds.forEach((item) => {
            if (item.booChecked) {
                ic.push(item.strAPIPartnerPK);
            }
        });
        return ic;
    });
    const [creds, setCreds] = useState(arrCreds.sort((a, b) => (a.strAPIPartnerPK > b.strAPIPartnerPK ? -1 : 1)));
    const [publicCreds, setPublicCreds] = useState(creds.length - internalCreds.length);
    const closeModalHandler = () => {
        setShowModal(false);
    };
    const generateKey = (APIKey, APIPartner_PK) => {
        let newCreds;
        const newCred = {
            strAPIName: strCompanyName,
            strAPIKey: APIKey,
            strAPISecret: undefined,
            strAPIPartnerPK: APIPartner_PK,
            booChecked: false,
            booNameEditing: false,
            booIsFirstSecret: true
        };
        if (APIPartner_PK === '') {
            newCreds = creds.filter((item) => item.strAPIPartnerPK !== '');
        }
        else {
            newCreds = [...creds];
        }
        newCreds.push(newCred);
        setCreds(newCreds);
        setPublicCreds(newCreds.length - internalCreds.length);
    };
    const newCredsHandler = () => {
        generateKey('', '');
        generateCertifyAPIKey(strCompanyID).then((data) => {
            generateKey(data.strAPICredValue, data.strAPIPartnerPK);
        });
    };
    const updateCredentials = (partnerPK, secret) => {
        const currentCred = creds.find((item) => item.strAPIPartnerPK === partnerPK);
        let newCreds = creds.filter((item) => item.strAPIPartnerPK !== partnerPK);
        currentCred.strAPISecret = secret;
        currentCred.booIsFirstSecret = false;
        newCreds.push(currentCred);
        newCreds = newCreds.sort((a, b) => (a.strAPIPartnerPK > b.strAPIPartnerPK ? -1 : 1));
        setCreds(newCreds);
        setPublicCreds(newCreds.length - internalCreds.length);
    };
    const generateSecret = (partnerPK) => {
        closeModalHandler();
        updateCredentials(partnerPK, 'loading');
        generateCertifyAPISecret(strCompanyID, partnerPK).then((data) => {
            updateCredentials(partnerPK, data.strAPICredValue);
        });
    };
    const confirmModalHandler = () => {
        switch (modalType) {
            case APIConfigModalTypes.Delete:
                closeModalHandler();
                deleteCertifyAPIKey(strCompanyID, selectedCredential).then(() => {
                    const newCreds = creds.filter((item) => item.strAPIPartnerPK !== selectedCredential);
                    setCreds(newCreds);
                    if (internalCreds.includes(selectedCredential)) {
                        const newInternalCreds = internalCreds.filter((pk) => pk !== selectedCredential);
                        setInternalCreds(newInternalCreds);
                        setPublicCreds(newCreds.length - newCreds.length);
                    }
                    else {
                        setPublicCreds(newCreds.length - internalCreds.length);
                    }
                });
                break;
            case APIConfigModalTypes.New:
                generateSecret(selectedCredential);
                break;
            default:
                break;
        }
    };
    const updateIntPubCreds = (newCreds) => {
        setInternalCreds(newCreds);
        setPublicCreds(creds.length - newCreds.length);
    };
    const changeInternalCredHandler = (event) => {
        const selectedCred = event.target.value;
        changeInternalCred(strCompanyID, selectedCred);
        let newCreds;
        if (internalCreds.includes(selectedCred)) {
            newCreds = internalCreds.filter((pk) => pk !== selectedCred);
        }
        else {
            newCreds = [...internalCreds];
            newCreds.push(selectedCred);
        }
        updateIntPubCreds(newCreds);
    };
    return (_jsxs(SingleColumnLayout, { children: [_jsx(APIConfigModal, { open: showModal, modalType: modalType, onConfirm: confirmModalHandler, onClose: closeModalHandler }), _jsxs(Container, { children: [_jsx(APIConfigHeader, { booIsCertifyAdmin: booIsCertifyAdmin, strCompanyName: strCompanyName, publicCreds: publicCreds, intMaxCreds: intMaxCreds }), creds.length > 0 &&
                        creds.map((item, i) => (_jsx(APIConfigCredential, { item: item, updateCheckbox: changeInternalCredHandler, editName: () => {
                                creds[i].booNameEditing = true;
                                setCreds([...creds]);
                            }, updateName: (newName) => {
                                if (newName) {
                                    updateAPIName(newName, creds[i].strAPIPartnerPK);
                                    creds[i].strAPIName = newName;
                                }
                                creds[i].booNameEditing = false;
                                setCreds([...creds]);
                            }, cancelName: () => {
                                creds[i].booNameEditing = false;
                                setCreds([...creds]);
                            }, internalCreds: internalCreds, booIsCertifyAdmin: booIsCertifyAdmin, deleteOnClick: () => {
                                setSelectedCredential(item.strAPIPartnerPK);
                                setModalType(APIConfigModalTypes.Delete);
                                setShowModal(true);
                            }, generateOnClick: () => {
                                // If this is the first secret, don't open the modal, and set the secret to a loading graphic, then to the result of the API call.
                                if (item.booIsFirstSecret) {
                                    generateSecret(item.strAPIPartnerPK);
                                }
                                else {
                                    // Set the selected credential, and open the modal.
                                    setSelectedCredential(item.strAPIPartnerPK);
                                    setModalType(APIConfigModalTypes.New);
                                    setShowModal(true);
                                }
                            } }, item.strAPIKey))), _jsx(Spacer, { size: 48 }), (booIsCertifyAdmin || publicCreds < intMaxCreds) && (_jsx(Button, { color: "primary", size: "large", onClick: newCredsHandler, children: $t('Create New Credentials') }))] })] }));
}
export default APIConfig;
